import { render, staticRenderFns } from "./ContactListItem.vue?vue&type=template&id=ace05c40&scoped=true"
import script from "./ContactListItem.vue?vue&type=script&lang=ts"
export * from "./ContactListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace05c40",
  null
  
)

export default component.exports